import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {
  Aangever,
  Aangifte,
  Aanspraken,
  ConserverendInkomen,
  OmschrijvingEnBedrag
} from "@snelstart-ventures/fiscaal/domain-logic";
import {FormArray, FormBuilder} from "@angular/forms";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-conserverend-inkomen',
  templateUrl: './conserverend-inkomen.component.html',
  styleUrls: ['./conserverend-inkomen.component.scss'],
})
export class ConserverendInkomenComponent {
}
